/**
 * LoadingState - one reusable loading indicator.
 *
 * Props:
 *   variant   'spinner' (default) | 'skeleton'
 *   label     (string, optional) - shown under the spinner
 *   rows      (number, default 3) - skeleton line count
 *   size      (number, default 48) - spinner size
 *   minHeight (number|string, default '40vh') - centered spinner area height
 *   sx        (object, optional)
 */

import React from 'react';
import { Box, CircularProgress, Skeleton, Stack, Typography } from '@mui/material';

const LoadingState = ({
  variant = 'spinner',
  label,
  rows = 3,
  size = 48,
  minHeight = '40vh',
  sx,
}) => {
  if (variant === 'skeleton') {
    return (
      <Stack spacing={1.5} sx={{ width: '100%', ...sx }}>
        <Skeleton variant="rectangular" height={160} sx={{ borderRadius: 1 }} />
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} variant="text" width={`${90 - i * 15}%`} />
        ))}
      </Stack>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        minHeight,
        width: '100%',
        ...sx,
      }}
    >
      <CircularProgress size={size} color="primary" />
      {label && (
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingState;
